import axios from 'axios'

export const buscaCep = async (cep: string) =>
  await axios.get(`https://viacep.com.br/ws/${cep}/json/`)
